import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { visibleAdminSections } from '@/features/admin/guard';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Opens the first admin section the user may see. */
export const Route = createFileRoute('/_app/admin/')({
  beforeLoad: async ({ context }) => {
    const { flags } = await context.queryClient.query(featuresQuery);
    const [first] = visibleAdminSections(context.me, flags);
    if (first === undefined) throw notFound();
    throw redirect({ to: first.to });
  },
});
